<script lang="ts">
  import Menu from "../../User/Menu/Menu.svelte";

  interface Params {
      columnPerPage: string;
  }
  let { columnPerPage = $bindable() } : Params = $props();

  function setColumns(event: Event) {
      const target = event.target as HTMLSelectElement;
      localStorage.setItem('columnPerPage', target.value);
  }
</script>

<div class="row">
    <div class="col-6">
        <Menu />
    </div>
    <div class="col-6">
        <select class="form-select" bind:value={columnPerPage} onchange={setColumns}>
            <option value="12">&#127074;</option>
            <option value="6">&#127074; &#127074;</option>
            <option value="4">&#127074; &#127074; &#127074;</option>
        </select>
    </div>
</div>